import React, { useState, useRef, useEffect } from 'react';
import { useUnreads, useSession } from '@talkjs/react';
import { FaMessage } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";

const TalkJsNotifications = () => {
    const unreads = useUnreads();
    const session = useSession();
    const [menu, setMenu] = useState(false);

    const handleMarkAllAsRead = async () => {
        try {
            if (!session?.unreads) return;
            await session.unreads.markAllAsRead();
        } catch (error) {
            console.error('Error marking all as read:', error);
        }
    };

    const getConversationSubject = (unreadItem) => {
        if (unreadItem.conversation?.subject) {
            return unreadItem.conversation.subject;
        }
        if (unreadItem.lastMessage?.conversation?.subject) {
            return unreadItem.lastMessage.conversation.subject;
        }
        return 'New Message';
    };

    const getSenderName = (unreadItem) => {
        if (unreadItem.lastMessage?.sender?.name) {
            return unreadItem.lastMessage.sender.name;
        }
        return 'Unknown';
    };

    const getCampaignId = (unreadItem) => {
        return unreadItem?.conversation?.custom?.cf_encryptedCampaignId ||
            unreadItem?.lastMessage?.conversation?.custom?.cf_encryptedCampaignId ||
            null;
    };

    // if (!session || !unreads) {
    //     return (
    //         <div onClick={() => setMenu()} className="dropdown d-inline-block">
    //             <button  className="btn header-item noti-icon waves-effect">
    //                 <FaMessage size={22} color="#08090a" />
    //             </button>
    //         </div>
    //     );
    // }
    return (
        <Dropdown
            isOpen={menu}
            toggle={() => setMenu(!menu)}
            className="dropdown d-inline-block"
            tag="li"
        >
            <DropdownToggle
                className="btn header-item noti-icon waves-effect"
                tag="button"
                id="page-header-notifications-dropdown"
            >
                <FaMessage size={22} color="#08090a" />
                {Array.isArray(unreads) && unreads.length > 0 && (
                    <span className="badge bg-pink rounded-pill">
                        {unreads.length}
                    </span>
                )}
            </DropdownToggle>

            <DropdownMenu className="dropdown-menu dropdown-menu-end p-0" style={{ minWidth: "300px" }}>
                <div className="p-3">
                    <Row className="align-items-center">
                        <Col>
                            <h6 className="m-0 font-size-16">Chat</h6>
                        </Col>
                        {Array.isArray(unreads) && unreads.length > 0 && (
                            <Col className="text-end">
                                <button
                                    onClick={handleMarkAllAsRead}
                                    className="btn btn-link text-pink p-0"
                                >
                                    Mark all as read
                                </button>
                            </Col>
                        )}
                    </Row>
                </div>

                <SimpleBar style={{ maxHeight: "230px" }}>
                    {!Array.isArray(unreads) || unreads.length === 0 ? (
                        <div className="notification-item text-reset p-3 text-center">
                            <p className="text-muted mb-0">No unread chats</p>
                        </div>
                    ) : (
                        unreads.map(conversation => {
                            if (!conversation) return null;
                            return (
                                <Link
                                    key={conversation.id}
                                    to={`/chat`}
                                    state={{ isComingFromLink: true, initialConversationId: conversation.conversation?.id || conversation.lastMessage?.conversation?.id }}
                                    className="text-reset notification-item border-bottom"
                                >
                                    <div className="d-flex p-3 border-top">
                                        <div className="flex-grow-1">
                                            <div style={{display:'flex',}} className="justify-content-between ">
                                                <h6 className="mt-0 mb-1">
                                                    {getConversationSubject(conversation)}
                                                </h6>
                                                <div className="font-size-12 ">
                                                    {conversation.lastMessage?.timestamp ?
                                                        new Date(conversation.lastMessage.timestamp).toLocaleString(undefined, {
                                                            year: 'numeric',
                                                            month: '2-digit',
                                                            day: '2-digit',
                                                            
                                                          }) :
                                                        ''}
                                                </div>
                                            </div>
                                            <p className="text-muted font-size-14 mb-1">
                                                {conversation.lastMessage?.body || ''}
                                            </p>
                                            <p className="text-muted mb-0 font-size-12">
                                                From: {getSenderName(conversation)}
                                            </p>
                                        </div>
                                    </div>
                                </Link>
                            );
                        })
                    )}
                    <Link to="/chat">
                        <div className="d-flex p-3 border-top text-center jc-center">
                            View All Chats
                        </div>
                    </Link>
                </SimpleBar>
            </DropdownMenu>
        </Dropdown>
    );
};

export default TalkJsNotifications;